import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33234b54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history-chart" }
const _hoisted_2 = { class: "chart-container" }

import {
  ref,
  onMounted,
  watch,
  onUnmounted,
} from 'vue'
import * as echarts from 'echarts'
import { getLineColor } from '@/utils'
import { queryReportChart } from '@/api'
import { CODE_ENUM } from '@/common/enum'
import { cloneDeep, set, get, isEmpty } from 'lodash'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'report-chart',
  props: ['visible', 'data'],
  emits: ['update:visible'],
  setup(__props, { emit: __emit }) {

const props = __props

const $emit = __emit

const getTitle = () => {
  return props.data?.reportName
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryData()
    }
  },
  {
    deep: true,
  }
)

const handleClose = () => {
  $emit('update:visible', false)
}

onMounted(() => {
  window.addEventListener('resize', resizeCharts)
})

onUnmounted(() => {
  window.removeEventListener('resize', resizeCharts)
})

const clearChart = () => {
  myChart?.clear?.()
  myChart?.dispose?.()
  myChart = null
}

const resizeCharts = () => {
  myChart?.resize?.()
}

const option = {
  title: {
    left: 20,
    top: 20,
  },
  grid: {
    left: 65,
    right: 40,
    top: 70,
    bottom: 30,
  },
  legend: {
    right: 30,
    top: 10,
  },
  tooltip: {
    trigger: 'axis',
  },
  xAxis: [
    {
      type: 'category',
      axisLabel: {
        inside: false,
        color: '#4E5969',
        align: 'center',
        margin: 13,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          type: 'solid',
          color: '#F2F3F5',
        },
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
      axisLabel: {
        color: '#4E5969',
      },
      splitLine: {
        lineStyle: {
          type: 'solid',
          color: '#F2F3F5',
        },
        show: true,
      },
    },
  ],
  series: [],
}

const deviceRef = ref()
const loading = ref(false)
let myChart: any = null
const queryData = async () => {
  loading.value = true
  const res: any = await queryReportChart({
    id: props?.data?.id,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { pointStatisticsMap = {} } = res.data || {}

    const keys = Object.keys(pointStatisticsMap)

    let moXaxis = null
    const series = keys.map((key: string, index: number) => {
      const { xaxis, yaxis, config, formatter } = pointStatisticsMap[key]
      moXaxis = xaxis
      return {
        data: yaxis,
        type: 'line',
        ...config,
        ...getLineColor(index),
        // 不让断开
        connectNulls: true,
        showAllSymbol: true,
        formatter,
        tooltip: {
          valueFormatter: tooltipFomatter(formatter),
        },
      }
    })

    const seriesData = series.map((item: any) => item.data)
    if (isEmptyData(seriesData.flat(Infinity))) {
      clearChart()
      return
    }

    const ops = cloneDeep(option)

    set(ops, 'series', series)
    set(ops, 'xAxis[0].data', moXaxis)

    clearChart()
    myChart = echarts.init(deviceRef.value)
    showEmpty.value = false
    myChart.setOption(ops)
  } else if (res?.code === 30900) {
    showEmpty.value = true
    clearChart()
  }
}

const showEmpty = ref(false)
const isEmptyData = (list: any) => {
  const reslut = list.filter((data: any) => data !== null).length === 0
  showEmpty.value = reslut
  return reslut
}

const tooltipFomatter = (formatter: string) => {
  return (value: string) => {
    return value !== null && value !== undefined ? value + formatter : '-'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: getTitle(),
    width: "1225",
    "before-close": handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "deviceRef",
            ref: deviceRef,
            class: "chart-box"
          }, null, 512),
          (showEmpty.value)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                description: '暂无数据',
                class: "ws_mt50"
              }))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, loading.value]
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})